import React from 'react'
import numbro from 'numbro'
import moment from 'moment'
import pluralize from 'pluralize'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectLocalisation } from '../../../../store/site'
import currencySymbol from '../../../../lib/currencySymbol'
import * as units from 'supporticon/utils/units'
import withToggle from 'constructicon/with-toggle'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Heading from 'constructicon/heading'
import Icon from 'constructicon/icon'

const Activity = ({
  activityType,
  amount,
  caption,
  classNames,
  country,
  createdAt,
  customFitnessType,
  distance,
  duration,
  elevation,
  isCustom,
  name,
  onToggleOn,
  styles,
  type,
  uom
}) => {
  const fitnessType = () => {
    if (isCustom) {
      return customFitnessType
    }

    switch (type) {
      case 'bike':
        return 'ride'
      case 'walk':
      case 'run':
      case 'ride':
      case 'swim':
      case 'hike':
        return type
      default:
        return 'run'
    }
  }

  const parseDistance = () => {
    if (uom === 'mi') {
      const distanceInMiles = units.convertMetersToMiles(distance)

      return distanceInMiles < 1 ? (
        numbro(distanceInMiles * 5280).format('0,0') + ' yd'
      ) : (
        numbro(distanceInMiles).format('0,0[.]0') + ' mi'
      )
    } else {
      return distance < 1000 ? (
        numbro(distance).format('0,0') + ' m'
      ) : (
        numbro(units.convertMetersToKm(distance)).format('0,0[.]0') + ' km'
      )
    }
  }

  const parseDuration = () => {
    if (duration >= 86400) {
      return `${Math.floor(moment.duration(duration, 'seconds').asDays())}d ${moment.duration(duration, 'seconds').hours()}h`
    } else if (duration >= 3600) {
      return `${moment.duration(duration, 'seconds').hours()}h ${moment.duration(duration, 'seconds').minutes()}m`
    } else {
      return `${moment.duration(duration, 'seconds').minutes()}m ${moment.duration(duration, 'seconds').seconds()}s`
    }
  }

  const parseElevation = () => {
    if (uom === 'mi') {
      return numbro(units.convertMetersToFeet(elevation)).format('0,00') + ' ft'
    } else {
      return numbro(elevation).format('0,0') + ' m'
    }
  }

  const renderIcon = () => {
    switch (activityType) {
      case 'fitness':
        return (
          <div className={classNames.icon}>
            <Icon color='light' size={isCustom ? 1 : 1.333} name={isCustom ? 'heart' : fitnessType()} />
          </div>
        )
      default:
        const currency = currencySymbol(country)
        const icon = currency === '£' ? 'pound' : currency === '€' ? 'euro' : 'dollar'

        return (
          <div className={classNames.icon}>
            <Icon color='light' name={icon} />
          </div>
        )
    }
  }

  const renderContent = () => {
    switch (activityType) {
      case 'fitness':
        return (
          <div className={classNames.content}>
            <Heading tag='span' size={0}>
              {isCustom ? (
                <span>
                  Logged{' '}
                  {numbro(distance).format('0,0')}{' '}
                  {pluralize(pluralize.singular(customFitnessType), distance)}{'. '}
                </span>
              ) : (
                <span>
                  Logged a{' '}
                  {!!distance && parseDistance()}{' '}
                  {fitnessType()}{'. '}
                </span>
              )}
              <small className={classNames.details}>
                {!!duration && `Time: ${parseDuration()}. `}
                {!!elevation && `Elevation: ${parseElevation()}`}
              </small>
            </Heading>
            {!!caption && (
              <div className={classNames.caption} onClick={() => onToggleOn()}>
                {caption}
              </div>
            )}
          </div>
        )
      default:
        return (
          <div className={classNames.content}>
            <Heading tag='span' size={0}>
              {`${name || 'Anonymous'} donated ${numbro(amount).formatCurrency('0,0.[00]')}`}
            </Heading>
          </div>
        )
    }
  }

  return (
    <li className={classNames.root}>
      {renderIcon()}
      {renderContent()}
      <span className={classNames.date}>{!!createdAt && moment(createdAt).fromNow()}</span>
    </li>
  )
}

const mapStateToProps = (state) => ({
  ...selectLocalisation(state)
})

export default compose(
  connect(mapStateToProps),
  withToggle,
  withStyles(styles)
)(Activity)
